export default class {
    constructor({
        id,
        audioTextTimeHandle,
        playingClass = 'is-playing',
        pausedClass = 'is-paused',
    }) {
        const el = document.getElementById(id);
        const button = el.querySelector('button');
        const audio = el.querySelector('audio');
        const time = el.querySelector(audioTextTimeHandle);
        const file = audio.getAttribute('data-file');

        audio.src = file;
        audio.load();

        function formatTime(totalSeconds) {
            if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
                return '0:00';
            }

            const seconds = Math.floor(totalSeconds);
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainder = seconds % 60;

            if (hours > 0) {
                return `${hours}:${String(minutes).padStart(2, '0')}:${String(remainder).padStart(2, '0')}`;
            }

            return `${minutes}:${String(remainder).padStart(2, '0')}`;
        }

        function updateTime() {
            if (!time) return;

            const current = formatTime(audio.currentTime);
            const duration = formatTime(audio.duration);

            time.textContent = `${current} / ${duration}`;
        }

        function setState(isPlaying) {
            button.classList.toggle(playingClass, isPlaying);
            button.classList.toggle(pausedClass, !isPlaying);
            button.setAttribute('aria-label', isPlaying ? 'Pause audio' : 'Play audio');
        }

        function handleClick() {
            if (audio.paused) {
                audio.play();
                return;
            }

            audio.pause();
        }

        function handleEnded() {
            setState(false);
            updateTime();
        }

        function handlePlay() {
            setState(true);
        }

        function handlePause() {
            setState(false);
        }

        button.addEventListener('click', handleClick);
        audio.addEventListener('play', handlePlay);
        audio.addEventListener('pause', handlePause);
        audio.addEventListener('ended', handleEnded);
        audio.addEventListener('timeupdate', updateTime);
        audio.addEventListener('loadedmetadata', updateTime);
        audio.addEventListener('durationchange', updateTime);

        updateTime();
    }
}
